import React from "react";

const IconCloseO = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 28 28">
      <g id="Group_1739" dataname="Group 1739" transform="translate(0 -0.5)">
        <g
          id="Ellipse_276"
          dataname="Ellipse 276"
          transform="translate(0 0.5)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        >
          <circle cx="14" cy="14" r="13" fill="none" />
        </g>
        <g id="Group_1736" dataname="Group 1736" transform="translate(10 10)">
          <path
            id="Path_9202"
            dataname="Path 9202"
            d="M122.324,253.74l8.693-8.693"
            transform="translate(-122.324 -245.047)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="2"
          />
          <path
            id="Path_9203"
            dataname="Path 9203"
            d="M131.018,253.74l-8.693-8.693"
            transform="translate(-122.324 -245.047)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconCloseO;
